import React, { useEffect, useRef } from "react";
import loading from "../../../../static/loading.svg";
import markdownIt from "markdown-it";
import "./index.less";
const md = markdownIt();

const Index = ({ list }) => {
  const scrollHeightRef = useRef({}); // 对话区域窗口

  const isBottomRef = useRef(true);

  const onScrollBottom = () => {
    requestAnimationFrame(() => {
      const divElement = scrollHeightRef.current;
      if (scrollHeightRef.current && isBottomRef.current) {
        divElement.scrollTop = divElement.scrollHeight;
      }
    });
  };

  const handleMouseMove = (e) => {
    const { target } = e;
    const currentHeight = target.scrollHeight - target.scrollTop;
    const clientHeight = target.clientHeight;
    if (target) {
      const isBottom = currentHeight - clientHeight <= 80;
      isBottomRef.current = isBottom;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      onScrollBottom();
    }, 0);
  }, [list]);

  return (
    <div className="AiDigitalChat">
      <div
        className="AiDigitalChatContent"
        ref={scrollHeightRef}
        onScroll={handleMouseMove}
      >
        {list.map((item, index) => {
          return item.type !== "send" ? (
            <div className="aiAnswer" key={index}>
              <div className="aiAnswerWarp">
                {!item.text ? (
                  <div
                    className="aiAnswerMessage"
                    style={{ paddingBottom: "0px" }}
                  >
                    <img
                      src={loading}
                      alt=""
                      style={{ width: "9vw", height: "6vw", marginTop: "2px" }}
                    />
                  </div>
                ) : (
                  <div
                    className="aiAnswerMessage"
                    dangerouslySetInnerHTML={{
                      __html: md.render(item.text),
                    }}
                  ></div>
                )}
              </div>
            </div>
          ) : (
            <div
              className="userProblem"
              key={index}
              style={{ display: !item.text ? "none" : "flex" }}
            >
              <div className="userProblemMessage">
                {item.text ? item.text : ""}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Index;
